module.exports = __webpack_public_path__ + "img/29_52.be7a4ef0.png";